import { render, staticRenderFns } from "./ArticleSeries.vue?vue&type=template&id=4fdeeaf2&scoped=true&"
import script from "./ArticleSeries.vue?vue&type=script&lang=js&"
export * from "./ArticleSeries.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSeries.vue?vue&type=style&index=0&id=4fdeeaf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdeeaf2",
  null
  
)

export default component.exports